import React, { useEffect, useRef, useState } from 'react';

import { TreeSelect, Typography } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useGetFieldsChange } from '../hook/useGetFieldsChange';

const SelectFieldsChanged = ({ fieldFullPath, ...otherProps }) => {
  const { treeData, getPropertyData } = useGetFieldsChange();

  const treeSelectRef = useRef();
  const [isEdit, setIsEdit] = useState(false);

  const property = Boolean(fieldFullPath) ? getPropertyData(fieldFullPath) : '';

  const displayName = property?.fullPathDisplayName || '';

  useEffect(() => {
    if (isEdit) treeSelectRef.current?.focus();
  }, [isEdit]);

  return (
    <>
      {isEdit ? (
        <TreeSelect
          ref={treeSelectRef}
          defaultOpen
          showSearch
          bordered={false}
          treeData={treeData}
          treeLine={{
            showLine: true,
            showLeafIcon: false,
          }}
          treeDefaultExpandAll
          placement='bottomRight'
          dropdownStyle={{ maxHeight: 400, overflow: 'auto', minWidth: 400 }}
          placeholder='Input to search property...'
          filterTreeNode={(inputValue, treeNode) => {
            const inputValueSearch = inputValue.toLowerCase().trim();

            const isDisplayNameMatched = treeNode.data?.propertyDisplayName
              ?.toLowerCase()
              ?.includes(inputValueSearch);

            const isModuleNameMatched = treeNode.data?.moduleDisplayName
              ?.toLowerCase()
              ?.includes(inputValueSearch);

            const isFieldNameMatched = treeNode.data?.fieldFullPath
              ?.toLowerCase()
              ?.includes(inputValueSearch);

            return isDisplayNameMatched || isFieldNameMatched || isModuleNameMatched;
          }}
          onDropdownVisibleChange={() => {
            setIsEdit(false);
          }}
          style={{ width: 184 }}
          {...otherProps}
        />
      ) : (
        <Typography.Text
          onClick={() => {
            setIsEdit(true);
          }}
          style={{
            backgroundColor: '#85c0e4',
            borderRadius: 4,
            marginRight: 4,
            padding: '0 4px',
            width: 180,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
            height: 22,
          }}
        >
          <Typography.Text ellipsis={{ tooltip: displayName }}>
            {displayName ? (
              displayName
            ) : (
              <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
                Please select value
              </span>
            )}
          </Typography.Text>
          <DownOutlined
            style={{
              cursor: 'pointer',
              width: 28,
              color: 'rgba(0, 0, 0, 0.25)',
            }}
          />
        </Typography.Text>
      )}
    </>
  );
};

export default SelectFieldsChanged;
